import { SERVICES } from "@/data/services";
import {
  Hammer, LayoutPanelLeft, Grid3x3, Square, PaintRoller, Droplets, Home, Layers, Wrench, Droplet, Zap, Settings, Calculator, ShowerHead
} from "lucide-react";

const ICONS = {
  Hammer, LayoutPanelLeft, Brick: Layers, Trowel: Wrench, Grid3x3, Square, PaintRoller, Droplets, Home, Droplet, Zap, Settings, ShowerHead,
};

export default function ServicesGrid() {
  const handleSelect = (serviceId) => {
    window.dispatchEvent(new CustomEvent("ps24-select-service", { detail: serviceId }));
  };

  return (
    <section id="servicios" className="bg-white scroll-mt-20">
      <div className="container mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-2xl mb-10 md:mb-14">
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#004B87] font-semibold mb-3">Especialidades</div>
          <h2 className="font-display font-semibold text-3xl md:text-4xl text-slate-900 tracking-tight">
            Servicios principales
          </h2>
          <p className="text-slate-500 mt-3">
            Cubrimos todas las fases de una reforma con personal propio, herramientas y seguros. Sin intermediarios.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {SERVICES.map((s) => {
            const Icon = ICONS[s.icon] || Hammer;
            const minPrice = Math.min(...s.items.map(i => i.price));
            const unit = s.items[0].unit;
            return (
              <div
                key={s.id}
                data-testid={`services-grid-${s.id}`}
                className="flex flex-col p-5 md:p-6 rounded-xl border border-slate-200 bg-white hover:border-[#004B87]/50 hover:-translate-y-0.5 hover:shadow-md transition-all"
              >
                <div className="w-11 h-11 rounded-lg bg-[#E6F0FA] text-[#004B87] grid place-items-center mb-4">
                  <Icon className="w-5 h-5" />
                </div>
                <div className="font-display font-semibold text-slate-900">{s.name}</div>
                <div className="text-xs text-slate-500 mt-1.5 leading-snug flex-1">{s.description}</div>
                <div className="text-[11px] uppercase tracking-[0.18em] mt-4 font-semibold text-slate-400">
                  Desde {minPrice} €/{unit}
                </div>
                <a
                  href="#calculadora"
                  onClick={() => handleSelect(s.id)}
                  data-testid={`services-grid-cta-${s.id}`}
                  className="mt-4 inline-flex items-center justify-center gap-2 h-9 px-3 rounded-lg border border-[#004B87] text-[#004B87] text-xs font-medium hover:bg-[#004B87] hover:text-white transition-colors"
                >
                  <Calculator className="w-3.5 h-3.5" />
                  Calcular estimación
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
